/**
 * Shared Mapbox access token.
 *
 * Prefers the build-time `VITE_MAPBOX_TOKEN` env var so production / Pages builds
 * can ship a URL-restricted token (e.g. `soleadlab-web-public`) without hardcoding
 * its value here. Falls back to the existing account Default public token literal
 * when the env var is absent, so local/dev and any env-less build keep working with
 * an identical map (no blank-map regression).
 *
 * The restricted token is supplied ONLY via `VITE_MAPBOX_TOKEN` at build time and is
 * never committed to the repo; the literal below is the un-restrictable Default token.
 */
const envToken = import.meta.env.VITE_MAPBOX_TOKEN;
export const MAPBOX_TOKEN =
  envToken || 'pk.eyJ1Ijoic29saWZpZWQiLCJhIjoiY21qemRvZnU4NHJlbTNmc2N3OXh0M2UybSJ9.Hsg36DPa6MikGdWpgQX42Q';
